import { LockClosedIcon, EyeIcon, EyeSlashIcon} from '@heroicons/react/24/solid';
import React, { useState } from 'react';
import { loginUser } from "../services/login";

const LoginPage = ({ onLoginSuccess }) => {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(prev => !prev);
  };

  const handleLogin = async (e) => {
  e.preventDefault(); // 🔥 THIS IS REQUIRED

  setIsLoading(true);
  setError(null);

  try {
    const result = await loginUser(email, password);

    if (result.status === "success") {
      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("user", JSON.stringify(result.user));
      localStorage.setItem("employee", JSON.stringify(result.employee));

      onLoginSuccess(); // redirect handled by App.jsx
    } else {
      setError(result.message);
    }
  } catch (err) {
    setError("Login failed. Please try again.");
  } finally {
    setIsLoading(false);
  }
};

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 px-4">
      <div className="w-full max-w-sm bg-white rounded-xl shadow-2xl p-8">

        <div className="flex flex-col items-center mb-8">
          <img
            src="/Krishok_Bondhu.jpeg"
            alt="Company Logo"
            className="w-28 h-auto mb-4 object-contain"
          />

          <h1 className="text-2xl font-extrabold text-gray-800 text-center">
            Krishok Bandhu Agro Limited
          </h1>

          <p className="mt-2 text-sm text-gray-500 text-center">
            Sign in with your Credentials.
          </p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">

          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
              Email Address
            </label>
            <input
              id="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your registered email"
              className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm
                         focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>

          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
              Password
            </label>
            <div className="relative"> 
              <input
                id="password"
                type={showPassword ? 'text' : 'password'} 
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm pr-10 // 👈 Added pr-10 padding
                          focus:ring-indigo-500 focus:border-indigo-500"
              />
              <button
                type="submit"
                onClick={togglePasswordVisibility}
                className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-gray-700"
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? (
                  <EyeSlashIcon className="h-5 w-5" />
                ) : (
                  <EyeIcon className="h-5 w-5" />
                )}
              </button>
            </div>
          </div>

          {error && (
            <p className="text-sm font-medium text-red-600 text-center">
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={isLoading}
            className={`w-full flex justify-center items-center py-2 px-4 rounded-lg text-white font-medium shadow-md
              ${isLoading ? 'bg-indigo-400' : 'bg-indigo-600 hover:bg-indigo-700'}`}
          >
            {isLoading ? (
              <svg className="animate-spin h-5 w-5 text-white mr-2" viewBox="0 0 24 24"></svg>
            ) : (
              <LockClosedIcon className="h-5 w-5 mr-2" />
            )}
            Log In
          </button>

        </form>

      </div>
    </div>
  );
};

export default LoginPage;
